<template>
    <div>
        <modal class="biz-lease-evaluation" :display="modalStatus.bizLeaseEvaluation" @modalStatus="closeModal" >
            <h1>我對租客的評價</h1>
            <div class="wrap">
                <div class="tenant">
                    <img src="@/assets/img/icon/user_shot_black.svg" alt="">
                    {{leaseEvaluation?leaseEvaluation.tenantName:''}}
                </div>
                <div class="contract-info">
                    <div>房源地址：{{leaseEvaluation?leaseEvaluation.houseAddress:''}}</div>
                    <div>租期：{{leaseEvaluation?getFormatDateTime(leaseEvaluation.contractBeginTime):''}} - {{leaseEvaluation?getFormatDateTime(leaseEvaluation.contractEndTime):''}}</div>
                    <div class="rate">評價星等：
                        <evaluation :key="componentKey" :rate="leaseEvaluation?leaseEvaluation.rate:0"></evaluation>
                    </div>
                    <div>評價內容：{{leaseEvaluation?leaseEvaluation.comment:''}}</div>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import Evaluation from '@/components/widge/Evaluation.vue';

import { mapGetters } from 'vuex'
import { 
    apiBizGetEvaluation,
    } from "@/apis/api.js"; 

export default {
    data () {
        return {
            leaseEvaluation: null,
            componentKey: 0
        }
    },
    props:{
        contractCid: null,
    },
    watch:{
        contractCid: function (val) {
            if(val){
                this.getLeaseEvaluation(val)
            }
            // this.getBillDetail(val)
        }
    },
    methods: {
        closeModal: function (type) {
            this.$store.dispatch('setModalStatus', {state: false, type: 'bizLeaseEvaluation'})
        },
        getLeaseEvaluation: function (contractCid) {
            let data = contractCid
            
            apiBizGetEvaluation(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.leaseEvaluation = res.data.result
                    this.componentKey += 1
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
    },
    computed: {
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
        Evaluation
    }
}
</script>
<style lang="scss"  >
    #modal.biz-lease-evaluation{
        .modal-content{
            width: 448px;
            // height: 324px;
            padding: 0 !important;
            .detail{
                >h1{
                    margin-top: 32px;
                    margin-bottom: 20px;
                }
                .wrap{
                    // margin-bottom: 184px;
                    width: 100%;
                    padding: 0 32px;
                    box-sizing: border-box;
                    .tenant{
                        display: flex;
                        align-items: center;
                        font-weight: 500;
                        font-size: 16px;
                        margin-bottom: 16px;
                        img{
                            margin-right: 8px;
                        }
                    }
                    .contract-info{
                        margin-bottom: 40px;
                        >div{
                            word-wrap : break-word;
                            margin-bottom: 16px;
                        }
                        .rate{
                            display: flex;
                            align-items: center;
                        }
                    }
                }   
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/modals/getLeaseEvaluation.vue